export const PURGE = 'PURGE';
export const STORE_USERNAME = 'STORE_USERNAME';
export const SET_STEPID = 'SET_STEPID';
export const SET_MAX_STEP = 'SET_MAX_STEP';

export const STORE_JOURNEY_ID = 'STORE_JOURNEY_ID';
export const STORE_JOURNEY_NAME = 'STORE_JOURNEY_NAME';
export const SET_JOURNEY_COMPLETED = 'SET_JOURNEY_COMPLETED';
export const STORE_INDUSTRY_NAME = 'STORE_INDUSTRY_NAME';
export const SET_JOURNEYS = 'SET_JOURNEYS';
export const SET_COLLABORATOR_JOURNEYS = 'SET_COLLABORATOR_JOURNEYS';
export const SET_IS_COLLABORATOR = 'SET_IS_COLLABORATOR';
export const STORE_CHECKLIST_ONE = 'STORE_CHECKLIST_ONE';
export const STORE_CHECKLIST_TWO = 'STORE_CHECKLIST_TWO';
export const DELETE_JOURNEY = 'DELETE_JOURNEY';
export const STORE_MILESTONE_COUNT = 'STORE_MILESTONE_COUNT';
export const SET_MILESTONE_COUNT = 'SET_MILESTONE_COUNT';
export const ADD_NEW_IDEA_ID = 'ADD_NEW_IDEA_ID';

export const ASSEMBLE_FULL_CHALLENGE = 'ASSEMBLE_FULL_CHALLENGE';
export const ADD_BUSINESS_CHALLENGE_ID = 'ADD_BUSINESS_CHALLENGE_ID';
export const ADD_COMPANY_GOAL = 'ADD_COMPANY_GOAL';
export const ADD_MEASURE_ONE = 'ADD_MEASURE_ONE';
export const ADD_MEASURE_TWO = 'ADD_MEASURE_TWO';
export const ADD_MEASURE_THREE = 'ADD_MEASURE_THREE';

export const ADD_PERSONA = 'ADD_PERSONA';
export const EDIT_PERSONA = 'EDIT_PERSONA';
export const DELETE_PERSONA = 'DELETE_PERSONA';

export const ADD_MILESTONE = 'ADD_MILESTONE';
export const ADD_TRIGGER = 'ADD_TRIGGER';
export const ADD_TRIUMPH = 'ADD_TRIUMPH';
export const ADD_GUIDE = 'ADD_GUIDE';
export const ADD_KEY = 'ADD_KEY';
export const ADD_CRISIS = 'ADD_CRISIS';
export const DELETE_MILESTONE = 'DELETE_MILESTONE';

export const ADD_MILESTONE_CONNECTOR = 'ADD_MILESTONE_CONNECTOR';
export const ADD_CONNECTOR_CONTENT = 'ADD_CONNECTOR_CONTENT';

export const ADD_QUIP_ACCESS_TOKEN = 'ADD_QUIP_ACCESS_TOKEN';
export const ADD_QUIP_LINK = 'ADD_QUIP_LINK';
export const UPDATE_QUIP_THREAD_ID = 'UPDATE_QUIP_THREAD_ID';
export const SET_QUIP_LOADING = 'SET_QUIP_LOADING';
export const SET_QUIP_ERROR = 'SET_QUIP_ERROR';

export const ADD_IDEA = 'ADD_IDEA';
export const DELETE_IDEA = 'DELETE_IDEA';
export const DELETE_MILESTONE_CONNECTOR = 'DELETE_MILESTONE_CONNECTOR';
export const SELECT_IDEA = 'SELECT_IDEA';
export const UPDATE_IDEA = 'UPDATE_IDEA';

export const UPDATE_MILESTONE_PRODUCT = 'UPDATE_MILESTONE_PRODUCT';
export const UPDATE_MILESTONE_PERSONA = 'UPDATE_MILESTONE_PERSONA';
export const UPDATE_MILESTONE_CONNECTOR_ORDER =
  'UPDATE_MILESTONE_CONNECTOR_ORDER';
export const UPDATE_CONNECTOR_PRODUCT = 'UPDATE_CONNECTOR_PRODUCT';
export const UPDATE_CONNECTOR_PERSONA = 'UPDATE_CONNECTOR_PERSONA';
export const UPDATE_CONNECTOR_CONTENT = 'UPDATE_CONNECTOR_CONTENT';

export const SET_SALESFORCE_PRODUCTS = 'SET_SALESFORCE_PRODUCTS';

export const SET_OPPORTUNITIES = 'SET_OPPORTUNITIES';
export const SET_OPP_LOADING = 'SET_OPP_LOADING';

export const SET_COLLABORATORS = 'SET_COLLABORATORS';
export const SET_SEARCHED_COLLABORATOR_LOADING =
  'SET_SEARCHED_COLLABORATOR_LOADING';
export const DELETE_COLLABORATOR = 'DELETE_COLLABORATOR';
export const ADD_ACTIVE_COLLABORATOR = 'ADD_ACTIVE_COLLABORATOR';
export const DELETE_ACTIVE_COLLABORATOR = 'DELETE_ACTIVE_COLLABORATOR';

export const SET_SLIDES_LINK = 'SET_SLIDES_LINK';
export const SET_SLIDES_LOADING = 'SET_SLIDES_LOADING';

export const SET_STAGEMAP_LOADING = 'SET_STAGEMAP_LOADING';

export const ADD_TOAST = 'ADD_TOAST';
export const REMOVE_TOAST = 'REMOVE_TOAST';

export const SET_COUNTDOWN = 'SET_COUNTDOWN';
